import { IImmunizationRecord } from "../../services/patient.service";

export class Immunization {
    public Id: string = "";
    public PatientId: string = "";
    public ProductName: string = "";
    public Description: string = "";
    public IsVaccineUnknown: boolean = false;
    public CvxCode: string = "";
    public Manufacturer: string = "";
    public LotNumber: string = "";
    public MvxCode: string = "";
    public DateOfVaccination: string = "";
    public DateOfDocumentation: string = "";
    public Status: number = null;
    public TypeOfRecord: number = null;
    public ReasonNotPerformed: string = null;
    public ReasonNotPerformedDisplayName: string = "";
    public Comments: string = "";
    public AdministeredBy: string = "";

    public constructor(data?: IImmunizationRecord) {
        if (!!data) {
            Object.assign(this, data);
        }
    }
}
